<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Fecha"
          label-for="fechaFacturacion"
          :labelCols="labelCols"
          description="Fecha estimada de facturación"
          horizontal>
          <b-input-group>
            <b-form-input 
              id="fechaFacturacion"
              v-model.trim="fechaFacturacion" 
              :state="fechaFacturacionValida"
              type="date">
            </b-form-input>
            <b-form-invalid-feedback id="fechaFacturacionFeedback">
              {{ fechaFacturacionInvalidaMsj }}
            </b-form-invalid-feedback>          
          </b-input-group>
        </b-form-group>

        <b-form-group
          label="Importe"
          label-for="importeFacturacion"
          :labelCols="labelCols"
          description="Importe neto (fee y financiación incluidos) sin reembolsos"
          horizontal>
          <b-input-group>
            <b-form-input 
              id="importeFacturacion"
              v-model.trim="$v.importeFacturacion.$model" 
              :state="importeFacturacionValido"
              type="text">
            </b-form-input>
            <b-form-invalid-feedback id="importeFacturacionFeedback">
              {{ importeFacturacionInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-input-group>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { decimal, minValue, maxValue } from 'vuelidate/lib/validators';
import moment from 'moment';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'PresupuestoInternoFacturacion',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    facturacion: {
      type: Object,
      default: null
    },
  },
  data: () => {
    return {
      fechaFacturacion: moment(new Date()).format('YYYY-MM-DD'),
      importeFacturacion: 0,

      fechaFacturacionValida: null,
      fechaFacturacionInvalidaMsj: '',
      importeFacturacionValido: null,
      importeFacturacionInvalidoMsj: '',

      labelCols: 2
    }
  },
  created() {
    if (this.facturacion) {
      this.fechaFacturacion = this.facturacion.fechaFacturacion;
      this.importeFacturacion = this.facturacion.importeFacturacion;
    }
  },
  computed: {
    ...mapFields([
      // 'vendedorComision',
      // 'montoBaseComision',
    ]),
    monedaSimbolo() {
      if (this.monedaId) {
        if (this.monedaId == 102) {  
          return 'usd';
        }
      }
      return '$';
    },
  },
  methods: {
    save() {
      let save = true;

      this.$v.$touch();

      if (this.$v.importeFacturacion.$error) {
        this.importeFacturacionValido = false;
        if (!this.$v.importeFacturacion.decimal) {
          this.importeFacturacionInvalidoMsj = 'El importe debe ser un valor numérico';
        } else {
          if (!this.$v.importeFacturacion.minValue) {
            this.importeFacturacionInvalidoMsj = 'El importe ingresado no es válido';
          }      
        }     
      } else {
        this.importeFacturacionValido = null;
        this.importeFacturacionInvalidoMsj = '';
      }

      if (!this.$v.$anyError) {
        if (save) {
          let facturacion = {
            fechaFacturacion: this.fechaFacturacion,
            importeFacturacion: parseFloat(this.importeFacturacion)
          }
          if (this.facturacion) {
            facturacion.id = this.facturacion.id;

            this.$store.dispatch('presupuestointerno/updateFechaFacturacion', facturacion)
              .then(() => this.$emit('close'))
              .catch(error => this.showErrorMsj(error));
          } else {
            this.$store.dispatch('presupuestointerno/addFechaFacturacion', facturacion)
              .then(() => this.$emit('close'))
              .catch(error => this.showErrorMsj(error));
          }
        }
      }
    },
    cancelar() {
      this.$emit('close')
    },
  },
  validations: {
    importeFacturacion: {
      decimal,
      minValue: minValue(0),
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
